import React, { useState } from 'react'
import { AgTechButton } from '../../Buttons/AgTechButtons'
import AgTechTitleDetailHeader from '../../Headers/AgTechTitleDetailHeader'
import AgTechModal from './AgTechModal'
import { logDev } from '@agtech/core/logging/AgTechLogger'
import AgTechHeaderDetail from '../../Headers/AgTechHeaderDetail'

export type AgTechStepModalStep = {
    name: string,
    description: string,
    content: () => JSX.Element
}

export type AgTechStepModalProps = {
    name: string,
    height?: string,
    width?: string,
    steps: AgTechStepModalStep[],
    intro?: () => JSX.Element,
    onComplete: () => void
}

const AgTechStepModal = (props: AgTechStepModalProps & {
    closeModal: () => void
}) => {

    return (
        <AgTechModal
            classes="agtech-warning-modal"
            height={props.height}
            width={props.width}
            closeModal={props.closeModal}
            showCloseButton={false}
        >
            <AgTechStepModalBody {...props} />
        </AgTechModal>
    )
}

export const AgTechStepModalBody = (props: AgTechStepModalProps) => {
    const [currentStepNumber, setCurrentStepNumber] = useState<number | undefined>(props.intro ? undefined : 0);
    const currentStep = currentStepNumber !== undefined ? props.steps[currentStepNumber] : undefined;

    return (
        <>
            {currentStep ? (
                <div className='column-based stretched flex'>
                    <div className='tall w-[320px] min-w-[320px] max-w-[320px] bg-light-gray border-r border-slate-200 row-based justify-center p-6 py-8 flex'>
                        <h1 className='text-xl font-semibold mb-10'>
                            {props.name}
                        </h1>
                        <div className='flexed row-based pl-2 flex'>
                            {props.steps.map((step, index) => {
                                const stepDotDiameter = 14;

                                let isActiveStep = currentStepNumber === index;
                                let isCompletedStep = index < currentStepNumber!;

                                let borderClasses = index === props.steps.length - 1 ? '' : 'border-l';
                                let activeClasses = isActiveStep ? 'color-highlight' : isCompletedStep ? 'color-green' : 'color-gray';

                                return  (
                                    <div key={step.name} className={`column-based ${borderClasses} container`} style={{ height: 56 }}>
                                        <div
                                            className={`${activeClasses} rounded-circle border mr-3`}
                                            style={{
                                                width: stepDotDiameter,
                                                height: stepDotDiameter,
                                                marginLeft: 0 - (stepDotDiameter / 2)
                                            }}
                                        />
                                        <h1 className='text-sm font-semibold heading-[14px]' style={{ lineHeight: stepDotDiameter + 'px' }}>{step.name}</h1>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className='flex-grow tall bg-white row-based non-scrollable flex'>
                        <div className='flexed wide p-6 py-8 row-based flex'>
                            <AgTechHeaderDetail
                                header={currentStep.name}
                                detail={currentStep.description}
                                settings={{
                                    header: {
                                        classes: '!text-xl'
                                    },
                                    detail: {
                                        classes: '!mt-2 text-[14px]'
                                    },
                                    classes: 'pb-6'
                                }}
                            />
                            {currentStep.content()}
                        </div>
                        <div className='wide column-based px-6 py-4 gap-x-3 border-t border-slate-200 flex'>
                            <AgTechButton
                                text='Back'
                                classes='!text-sm'
                                disableIf={currentStepNumber === 0}
                                action={() => setCurrentStepNumber(currentStepNumber! - 1)}
                            />
                            <AgTechButton
                                text={currentStepNumber === props.steps.length - 1 ? 'Finish' : 'Next Step'}
                                classes='!text-sm button-highlight'
                                action={() => {
                                    if (currentStepNumber === props.steps.length - 1) {
                                        props.onComplete();
                                    } else {
                                        setCurrentStepNumber(currentStepNumber! + 1);
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            ) : props.intro ? (
                <>
                    {props.intro()}
                </>
            ) : (
                <>
                </>
            )}
        </>
    )
}

export const showStepModal = async (
    props: AgTechStepModalProps,
    context: {
        showModal: (modalRenderProp: (modalId: string) => React.ReactNode) => void,
        closeModal: (modalId: string) => void
    }
) => {
    return new Promise<void>((res) => {
        logDev('Showing action modal', {
            executionProps: props
        });
    
        context.showModal((modalId) => {
            return (
                <AgTechStepModal
                    {...props}
                    closeModal={() => {
                        context.closeModal(modalId);
                        res();
                    }}
                />
            )
        });
    });
}

export default AgTechStepModal